import {Fragment, useSyncExternalStore} from 'react'
import {createPortal} from 'react-dom'
import {CopilotChatDiffButton} from './CopilotChatDiffButton'
import {CopilotChatDiffMenuItem} from './CopilotChatDiffMenuItem'
import {CopilotDiffEntryElement} from './CopilotDiffEntryElement'

/**
 * One partial for each Rails diff view inserts React components for each file, minimizing the performance cost of
 * instantiating many partials. In other words:
 *
 * > _One Partial to rule them all, One Partial to find them, One Partial to bring them all and in the React bind them._
 */
export function CopilotCodeChatPartial() {
  const entries = useSyncExternalStore(
    onUpdate => {
      CopilotDiffEntryElement.store.addEventListener('update', onUpdate)
      return () => CopilotDiffEntryElement.store.removeEventListener('update', onUpdate)
    },
    () => CopilotDiffEntryElement.store.entries,
  )

  return (
    <>
      {entries.map(
        entry =>
          entry.fileDiffReference && (
            <Fragment key={entry.fileDiffReference.id}>
              {entry.floatingMenuSlot &&
                createPortal(
                  <CopilotChatDiffButton fileDiffReference={entry.fileDiffReference} />,
                  entry.floatingMenuSlot,
                )}
              {entry.menuItemsSlot &&
                createPortal(
                  <CopilotChatDiffMenuItem fileDiffReference={entry.fileDiffReference} />,
                  entry.menuItemsSlot,
                )}
            </Fragment>
          ),
      )}
    </>
  )
}

try{ CopilotCodeChatPartial.displayName ||= 'CopilotCodeChatPartial' } catch {}